import { GRID_OPTIONS_HEADER } from "../../../../Data/UiKit/Grid";

export const GridOptionTableHead = () => {
  return (
    <thead>
      <tr>
        <th></th>
        <th className="text-center">Extra small<br />
          <small>&lt;576px</small>
        </th>
        {GRID_OPTIONS_HEADER.map(({ title, small, className }, index) => (
          <th className="text-center" key={index}>{title}
            <br />
            <small className={className && className}>{small}</small>
          </th>
        ))}
      </tr>
    </thead>
  );
};
